import { registerPlugin } from "@capacitor/core";

const DeviceID = registerPlugin("DeviceID");

export default DeviceID;
